module.exports = __webpack_public_path__ + "fonts/feather.6a750f01.ttf";